const state = {
    customers: [],
    custId: [],
    contacts: [],
    quotation: [],
    invoice: [],
    order: [],
    source: [],
    opportunity: [],
    complaint: [],
    details:[],
    profiledetails:[],
    loading: false
};

export default state;